import { render, staticRenderFns } from "./addresslist.vue?vue&type=template&id=70a1eb56&scoped=true"
import script from "./addresslist.vue?vue&type=script&lang=js"
export * from "./addresslist.vue?vue&type=script&lang=js"
import style0 from "./addresslist.vue?vue&type=style&index=0&id=70a1eb56&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a1eb56",
  null
  
)

export default component.exports